import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ApiResponse,
  ZipCoverageDownloadResponse,
  ZipCoverageUIResponse,
} from "../../models/ApiResponse";
import agent from "../../api/agent";
import { ZipCoverageResponse } from "../../models/responseModels/zipCoverageResponse";
import {
  AddZipCoverageRequest,
  UpdateZipCoverageRequest,
} from "../../models/requestModels/zipCoverageRequest";

type InitialState = {
  isLoading: boolean;
  zipCoverageList: ZipCoverageResponse[];
  errorMessage: string | null;
};

const initialState: InitialState = {
  isLoading: false,
  zipCoverageList: [],
  errorMessage: null,
};

export const getZipCoverageList = createAsyncThunk<ZipCoverageUIResponse>(
  "zipCoverage/GetZipCoverageList",
  async () => {
    const response = await agent.ZipCoverageAgent.getZipCoverageList();
    return response;
  }
);

export const downloadZipCoverageDataToCsv = createAsyncThunk<
  ZipCoverageDownloadResponse,
  ZipCoverageResponse[]
>("zipCoverage/downloadCsv", async (zipCoverageData: ZipCoverageResponse[]) => {
  const response = await agent.ZipCoverageAgent.zipCoverageCsvDownload(
    zipCoverageData
  );
  return response;
});

export const downloadZipCoverageDataToXlsx = createAsyncThunk<
  Blob,
  ZipCoverageResponse[]
>(
  "zipCoverage/DownloadXlsx",
  async (zipCoverageData: ZipCoverageResponse[]) => {
    const response = await agent.ZipCoverageAgent.zipCoverageXlsxDownload(
      zipCoverageData
    );
    return response;
  }
);

export const updateZipCoverage = createAsyncThunk<
  ApiResponse,
  UpdateZipCoverageRequest
>(
  "zipCoverage/updateZipCoverage",
  async (updateZipCoverageRequest: UpdateZipCoverageRequest) => {
    const response = await agent.ZipCoverageAgent.updateZipCoverage(
      updateZipCoverageRequest
    );
    return response;
  }
);

export const deleteZipCoverage = createAsyncThunk<
  ApiResponse,
  UpdateZipCoverageRequest
>(
  "zipCoverage/deleteZipCoverage",
  async (updateZipCoverageRequest: UpdateZipCoverageRequest) => {
    const response = await agent.ZipCoverageAgent.deleteZipCoverage(
      updateZipCoverageRequest
    );
    return response;
  }
);

export const addZipCoverage = createAsyncThunk<
  ApiResponse,
  AddZipCoverageRequest
>(
  "zipCoverage/addZipCoverage",
  async (addZipCoverageRequest: AddZipCoverageRequest) => {
    const response = await agent.ZipCoverageAgent.addZipCoverage(
      addZipCoverageRequest
    );
    return response;
  }
);

const zipCoverageSlice = createSlice({
  name: "zipCoverage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getZipCoverageList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getZipCoverageList.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.isSuccess) {
          state.zipCoverageList = action.payload.data;
        } else {
          state.zipCoverageList = [];
        }
      })
      .addCase(getZipCoverageList.rejected, (state, action) => {
        state.isLoading = false;
        state.zipCoverageList = [];
        state.errorMessage = action.error.message!;
      });
  },
});

export default zipCoverageSlice.reducer;
